export default "__VITE_ASSET__DlCyx5CI__"